import React, { useReducer, createContext } from 'react';

export const AppContext = createContext({});

const initialState = {
  appError: false,
  appLoading: true,
  animationLoadingTimeout: 1000,
  title: 'TMS',
  path: null,
  options: {},
  isCollapsed: true,
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET_APP_ERROR':
      return {
        ...state,
        appError: payload,
      };
    case 'SET_APP_LOADING':
      return {
        ...state,
        appLoading: payload,
      };
    case 'SET_TITLE':
      document.title = `${payload} - HepsiJET Müşteri Portalı`;
      return {
        ...state,
        title: payload,
      };
    case 'SET_PATH':
      return {
        ...state,
        path: payload,
      };
    case 'SET_OPTIONS':
      return {
        ...state,
        options: payload,
      };
    case 'SET_VIEW_LOADING':
      return {
        ...state,
        viewLoading: payload,
      };
    case 'SET_IS_COLLAPSED':
      return {
        ...state,
        isCollapsed: payload,
      };
    default:
      break;
  }
};

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider
      value={{
        ...state,
        dispatch,
        setAppLoading: (val) =>
          dispatch({ type: 'SET_APP_LOADING', payload: val }),
        setAppError: (val) => dispatch({ type: 'SET_APP_ERROR', payload: val }),
        setIsCollapsed: (val) =>
          dispatch({ type: 'SET_IS_COLLAPSED', payload: val }),
        // setTitle: (val) => dispatch({ type: 'SET_TITLE', payload: val }),
        // setPath: (val) => dispatch({ type: 'SET_PATH', payload: val }),
        // setOptions: (val) => dispatch({ type: 'SET_OPTIONS', payload: val }),
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
